import { saveAs } from 'file-saver';

const Submit = (data) => {
  const handleDownload = () => {
    const newData = JSON.parse(data.data)
    const dataToWrite = newData.records.map(record => `${record.QualifiedApiName}\n`)
    dataToWrite.unshift("Object Names\n")
    dataToWrite[dataToWrite.length - 1].trim()
    const file = new Blob([...dataToWrite], { type: 'application/vnd.ms-excel' });
    saveAs(file, 'objects.csv');
  };

  return (
    <button onClick={handleDownload}>
      Submit
    </button>
  );
};

export default Submit;